exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".img-fluid[data-v-7eedfcb2]{height:300px;width:448px}.flex-item[data-v-7eedfcb2]{text-align:center}.zoom[data-v-7eedfcb2]{transition:transform 1s}.zoom[data-v-7eedfcb2]:hover{transform:scale(1.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eedfcb2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Hotels/Habitaciones.vue
// module id = 568
// module chunks = 2